import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function LabourProfile() {
  const navigate = useNavigate();
  const [labour, setLabour]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pwForm, setPwForm]   = useState({ current:"", newPass:"", confirm:"" });
  const [pwError, setPwError] = useState("");
  const [pwSuccess, setPwSuccess] = useState("");
  const [pwLoading, setPwLoading] = useState(false);
  const [showPwSection, setShowPwSection] = useState(false);

  const navItems = [
    { label:"Dashboard",     emoji:"🏠", path:"/labour/dashboard" },
    { label:"My Attendance", emoji:"📅", path:"/labour/attendance" },
    { label:"My Salary",     emoji:"💰", path:"/labour/salary" },
    { label:"My Payments",   emoji:"💳", path:"/labour/payments" },
    { label:"Profile",       emoji:"👤", path:"/labour/profile", active:true },
  ];

  useEffect(()=>{
    const fetch = async()=>{
      try{
        const res = await api.get("/labour/me");
        setLabour(res.data.labour);
      }catch(e){console.error(e);}
      finally{setLoading(false);}
    };
    fetch();
  },[]);

  const handleChangePassword = async()=>{
    setPwError(""); setPwSuccess("");
    if(!pwForm.current||!pwForm.newPass||!pwForm.confirm){ setPwError("All fields required"); return; }
    if(pwForm.newPass!==pwForm.confirm){ setPwError("New passwords do not match"); return; }
    if(pwForm.newPass.length<6){ setPwError("Password must be at least 6 characters"); return; }
    setPwLoading(true);
    try{
      await api.put("/labour/change-password",{ currentPassword:pwForm.current, newPassword:pwForm.newPass });
      setPwSuccess("Password changed successfully! ✅");
      setPwForm({current:"",newPass:"",confirm:""});
    }catch(e){
      setPwError(e.response?.data?.message||"Failed to change password");
    }finally{setPwLoading(false);}
  };

  const ini = labour?.name?.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase()||"?";

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        body{font-family:'Plus Jakarta Sans',sans-serif;background:#FAF7F4;}
        .sidebar{width:220px;flex-shrink:0;background:#fff;border-right:1.5px solid #E7E5E4;padding:24px 14px;display:flex;flex-direction:column;gap:6px;position:sticky;top:0;height:100vh;overflow-y:auto;}
        .topbar{display:none;}
        .hamburger{display:none;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;border:1.5px solid #E7E5E4;background:#fff;cursor:pointer;flex-shrink:0;}
        .sidebar-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:40;}
        .nav-btn{display:flex;align-items:center;gap:9px;width:100%;padding:10px 12px;border-radius:10px;border:none;background:none;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:600;color:#78716C;cursor:pointer;transition:background .15s,color .15s;text-align:left;}
        .nav-btn:hover,.nav-btn.active{background:#FEF3C7;color:#D97706;}
        .nav-btn.danger:hover{background:#FEF2F2;color:#DC2626;}
        .pw-input{width:100%;padding:11px 14px;border:1.5px solid #E7E5E4;border-radius:10px;fontFamily:'Plus Jakarta Sans',sans-serif;font-size:14px;color:#1C1917;outline:none;background:#FFF7ED;transition:border-color .2s;}
        .pw-input:focus{border-color:#D97706;box-shadow:0 0 0 3px rgba(217,119,6,.1);}
        @media(max-width:768px){
          .sidebar{position:fixed;left:0;top:0;z-index:50;transform:translateX(-100%);transition:transform .28s ease;height:100%;}
          .sidebar.open{transform:translateX(0);}
          .sidebar-overlay.open{display:block;}
          .topbar{display:flex;align-items:center;gap:12px;padding:14px 16px;background:#fff;border-bottom:1.5px solid #E7E5E4;position:sticky;top:0;z-index:30;}
          .hamburger{display:flex;}
          .main-wrap{flex-direction:column!important;}
          .main-content{padding:16px!important;}
        }
        @media(min-width:769px) and (max-width:1100px){.sidebar{width:190px;}}
      `}</style>

      <div className="main-wrap" style={{display:"flex",minHeight:"100vh",fontFamily:"'Plus Jakarta Sans',sans-serif",background:"#FAF7F4"}}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={()=>setSidebarOpen(false)}/>

        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"28px",padding:"0 4px"}}>
            <div style={{width:"36px",height:"36px",background:"linear-gradient(135deg,#92400E,#D97706)",borderRadius:"10px",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <span style={{fontSize:"18px"}}>🪚</span>
            </div>
            <div>
              <p style={{fontWeight:"800",fontSize:"15px",color:"#1C1917"}}>Craftigo</p>
              <p style={{fontSize:"11px",color:"#A8A29E",fontWeight:"500"}}>Labour Panel</p>
            </div>
          </div>
          <p style={{fontSize:"11px",fontWeight:"700",color:"#C4B5A4",letterSpacing:"0.7px",textTransform:"uppercase",padding:"0 6px",marginBottom:"6px"}}>Menu</p>
          {navItems.map(n=>(
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`} onClick={()=>{navigate(n.path);setSidebarOpen(false);}}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{flex:1}}/>
          <div style={{padding:"12px",background:"#E0F2FE",borderRadius:"12px",border:"1px solid #BAE6FD",marginBottom:"10px"}}>
            <p style={{fontSize:"12px",fontWeight:"700",color:"#0369A1"}}>🔨 Labour</p>
            <p style={{fontSize:"11px",color:"#0369A1",marginTop:"2px",opacity:.8}}>{labour?.name||"..."}</p>
          </div>
          <button className="nav-btn danger" onClick={()=>{localStorage.clear();navigate("/login");}}>🚪 Logout</button>
        </aside>

        <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
          <div className="topbar">
            <button className="hamburger" onClick={()=>setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{fontWeight:"800",fontSize:"16px",color:"#1C1917"}}>👤 Profile</span>
          </div>

          <main className="main-content" style={{padding:"28px 28px",flex:1,overflowY:"auto",maxWidth:"680px"}}>
            <div style={{marginBottom:"24px"}}>
              <h1 style={{fontSize:"24px",fontWeight:"800",color:"#1C1917",letterSpacing:"-0.5px"}}>My Profile</h1>
              <p style={{fontSize:"13px",color:"#A8A29E",marginTop:"3px"}}>Your account information</p>
            </div>

            {loading ? (
              <div style={{padding:"60px",textAlign:"center"}}>
                <div style={{width:"32px",height:"32px",border:"3px solid #FDE68A",borderTop:"3px solid #D97706",borderRadius:"50%",animation:"spin .7s linear infinite",margin:"0 auto"}}/>
              </div>
            ) : (
              <>
                {/* Profile card */}
                <div style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"20px",padding:"24px",marginBottom:"16px",animation:"fadeUp .4s ease both"}}>
                  {/* Avatar + name */}
                  <div style={{display:"flex",alignItems:"center",gap:"16px",marginBottom:"24px",paddingBottom:"20px",borderBottom:"1px solid #F5F5F4"}}>
                    <div style={{width:"64px",height:"64px",borderRadius:"50%",background:"linear-gradient(135deg,#DBEAFE,#BAE6FD)",border:"2px solid #BAE6FD",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"22px",fontWeight:"800",color:"#0369A1",flexShrink:0}}>
                      {ini}
                    </div>
                    <div>
                      <p style={{fontSize:"20px",fontWeight:"800",color:"#1C1917"}}>{labour?.name}</p>
                      <p style={{fontSize:"13px",color:"#78716C",marginTop:"2px"}}>{labour?.email}</p>
                      <span style={{display:"inline-flex",marginTop:"6px",padding:"3px 10px",borderRadius:"20px",background:"#E0F2FE",border:"1px solid #BAE6FD",color:"#0369A1",fontSize:"11px",fontWeight:"700",textTransform:"capitalize"}}>
                        🔨 Labour
                      </span>
                    </div>
                  </div>

                  {/* Info rows */}
                  <div style={{display:"flex",flexDirection:"column",gap:"14px"}}>
                    {[
                      {label:"Full Name",        val:labour?.name,           icon:"👤"},
                      {label:"Email",            val:labour?.email,          icon:"📧"},
                      {label:"Role",             val:"Labour",               icon:"🔨"},
                      {label:"Daily Rate", val:labour?.dailyRate?`₹${labour.dailyRate}/day`:"Not set", icon:"💰"},
                      {label:"Carpenter",
                      val: (() => {
                        const cb = labour?.createdBy;
                        if (!cb) return "Not assigned";
                        if (typeof cb === "object" && cb.name) return cb.name;
                        // Still an ObjectId string — means populate failed
                        return "Fetching...";
                      })(),
                      icon:"🪚"},
                      {label:"Member Since",     val:labour?.createdAt?new Date(labour.createdAt).toLocaleDateString("en-IN",{day:"numeric",month:"long",year:"numeric"}):"—", icon:"📅"},
                    ].map(row=>(
                      <div key={row.label} style={{display:"flex",alignItems:"center",gap:"12px",padding:"12px 14px",background:"#FAF7F4",borderRadius:"12px"}}>
                        <span style={{fontSize:"18px",flexShrink:0}}>{row.icon}</span>
                        <div style={{flex:1,minWidth:0}}>
                          <p style={{fontSize:"11px",fontWeight:"700",color:"#A8A29E",textTransform:"uppercase",letterSpacing:"0.5px"}}>{row.label}</p>
                          <p style={{fontSize:"14px",fontWeight:"600",color:"#1C1917",marginTop:"2px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.val||"—"}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Change Password */}
                <div style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"16px",overflow:"hidden",animation:"fadeUp .4s .05s ease both"}}>
                  <button
                    onClick={()=>setShowPwSection(!showPwSection)}
                    style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px 20px",background:"none",border:"none",fontFamily:"'Plus Jakarta Sans',sans-serif",cursor:"pointer"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
                      <span style={{fontSize:"18px"}}>🔒</span>
                      <span style={{fontSize:"14px",fontWeight:"700",color:"#1C1917"}}>Change Password</span>
                    </div>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{transform:showPwSection?"rotate(180deg)":"rotate(0)",transition:"transform .2s"}}>
                      <path d="M6 9l6 6 6-6" stroke="#78716C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>

                  {showPwSection && (
                    <div style={{padding:"0 20px 20px",borderTop:"1px solid #F5F5F4"}}>
                      <div style={{display:"flex",flexDirection:"column",gap:"12px",marginTop:"16px"}}>
                        {[
                          {label:"Current Password",  key:"current",  ph:"Enter current password"},
                          {label:"New Password",       key:"newPass",  ph:"Enter new password"},
                          {label:"Confirm Password",   key:"confirm",  ph:"Confirm new password"},
                        ].map(f=>(
                          <div key={f.key}>
                            <label style={{fontSize:"12px",fontWeight:"700",color:"#44403C",display:"block",marginBottom:"6px"}}>{f.label}</label>
                            <input type="password" placeholder={f.ph} value={pwForm[f.key]}
                              onChange={e=>setPwForm({...pwForm,[f.key]:e.target.value})}
                              className="pw-input"
                              style={{width:"100%",padding:"11px 14px",border:"1.5px solid #E7E5E4",borderRadius:"10px",fontFamily:"'Plus Jakarta Sans',sans-serif",fontSize:"14px",color:"#1C1917",outline:"none",background:"#FFF7ED"}}
                              onFocus={e=>{e.target.style.borderColor="#D97706";e.target.style.boxShadow="0 0 0 3px rgba(217,119,6,.1)"}}
                              onBlur={e=>{e.target.style.borderColor="#E7E5E4";e.target.style.boxShadow="none"}}
                            />
                          </div>
                        ))}
                        {pwError && <p style={{fontSize:"13px",color:"#DC2626",fontWeight:"600",padding:"10px 14px",background:"#FEF2F2",borderRadius:"10px",border:"1px solid #FECACA"}}>{pwError}</p>}
                        {pwSuccess && <p style={{fontSize:"13px",color:"#059669",fontWeight:"600",padding:"10px 14px",background:"#D1FAE5",borderRadius:"10px",border:"1px solid #A7F3D0"}}>{pwSuccess}</p>}
                        <button onClick={handleChangePassword} disabled={pwLoading}
                          style={{padding:"12px",borderRadius:"12px",border:"none",background:"#D97706",fontFamily:"'Plus Jakarta Sans',sans-serif",fontSize:"14px",fontWeight:"700",color:"#fff",cursor:"pointer",opacity:pwLoading?.7:1,transition:"all .15s"}}>
                          {pwLoading?"Changing…":"Update Password"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Logout */}
                <button onClick={()=>{localStorage.clear();navigate("/login");}}
                  style={{width:"100%",marginTop:"16px",padding:"13px",borderRadius:"14px",border:"1.5px solid #FECACA",background:"#FEF2F2",fontFamily:"'Plus Jakarta Sans',sans-serif",fontSize:"14px",fontWeight:"700",color:"#DC2626",cursor:"pointer",transition:"all .15s",animation:"fadeUp .4s .1s ease both"}}
                  onMouseEnter={e=>{e.currentTarget.style.background="#DC2626";e.currentTarget.style.color="#fff"}}
                  onMouseLeave={e=>{e.currentTarget.style.background="#FEF2F2";e.currentTarget.style.color="#DC2626"}}>
                  🚪 Logout
                </button>
              </>
            )}
          </main>
        </div>
      </div>
    </>
  );
}